module.exports = {
      id: "corona-updates-icon-usage",
      viewBox: "0 0 25.374 25.18",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#corona-updates-icon",
      toString: function () {
        return this.url;
      }
    }